.root {
  position: relative;
  display: inline-block;
  min-width: 1.5rem;
  padding: 0 0.25rem;
  font-weight: inherit;
  background: transparent;
  border: none;

  &:hover:not([aria-disabled="true"]) {
    color: var(--link-hover);

    .content {
      text-decoration: underline;
    }
  }

  &:focus {
    color: var(--link-focus);

    .content {
      text-decoration: underline;
    }
  }

  &:active {
    &:not([aria-disabled="true"]) {
      color: var(--primary);

      .content {
        text-decoration: underline;
        text-decoration-thickness: 1px;
        text-decoration-color: currentColor;
      }
    }
  }
}

.iconAfter {
  padding-right: 1.25rem;
}

.iconBefore {
  padding-left: 1.25rem;
}

.icon {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: transform 0.5s ease;

  .iconAfter & {
    right: -0.25rem;
  }

  .iconBefore & {
    left: 0.5rem;
  }

  .iconSolo & {
    left: 50%;
  }
}

.block {
  display: block;
}

.colorPrimary {
  color: var(--link);
}

.colorInherit {
  color: inherit;
}

.content {
  display: inline-block;
  line-height: 1em;
  text-decoration: inherit;
}
